'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidRefresh = function IoAndroidRefresh(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 30.3c4.3 0 8.1-2.6 9.6-6.5h3.6c-1.7 5.7-6.9 10-13.2 10-7.7 0-13.8-6.2-13.8-13.8s6.2-13.7 13.8-13.7c3.7 0 7.1 1.5 9.6 4l4.1-4v12h-12l5.4-5.5c-1.8-1.9-4.3-3.1-7.2-3.1-5.6 0-10.3 4.6-10.3 10.3s4.7 10.3 10.4 10.3z' })
        )
    );
};

exports.default = IoAndroidRefresh;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-refresh.js
// module id = 2134
// module chunks = 0